export class PromotionInsertCommand {
    public catTipoOrganismoIdIOJ!: number;
    public oij!: number;
    public identificadorExpediente!: number;
    public numeroExpedienteOIJ!: string;
    public existeEE!: boolean;
    public urlEE!: string;
    public asuntoNeunId!: number;
    public catOrganismoIdDes!: number;
    public numExpedienteDes!: string;
    public catTipoAsuntoIdDes!: number;
    public catTipoProcedimientoDes!: number;
    public catMateriaIdDes!: number;
    public guidRel!: string;
}
